/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalletPackItem } from './PalletPackItem';
import {
    PalletPackItemFromJSON,
    PalletPackItemFromJSONTyped,
    PalletPackItemToJSON,
    PalletPackItemToJSONTyped,
} from './PalletPackItem';
import type { BoxPackItem } from './BoxPackItem';
import {
    BoxPackItemFromJSON,
    BoxPackItemFromJSONTyped,
    BoxPackItemToJSON,
    BoxPackItemToJSONTyped,
} from './BoxPackItem';

/**
 * 
 * @export
 * @interface PackingSaveReqVo
 */
export interface PackingSaveReqVo {
    /**
     * 订单 id
     * @type {number}
     * @memberof PackingSaveReqVo
     */
    orderId: number;
    /**
     * 打开包装作业时返回的商品基线版本
     * @type {string}
     * @memberof PackingSaveReqVo
     */
    packingGoodsVersion: string;
    /**
     * 运输箱列表
     * @type {Array<BoxPackItem>}
     * @memberof PackingSaveReqVo
     */
    boxes?: Array<BoxPackItem>;
    /**
     * 运输托盘列表（箱子页全量保存商品直接上托明细，不覆盖托盘及箱上托数据）
     * @type {Array<PalletPackItem>}
     * @memberof PackingSaveReqVo
     */
    pallets?: Array<PalletPackItem>;
}

/**
 * Check if a given object implements the PackingSaveReqVo interface.
 */
export function instanceOfPackingSaveReqVo(value: object): value is PackingSaveReqVo {
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('packingGoodsVersion' in value) || value['packingGoodsVersion'] === undefined) return false;
    return true;
}

export function PackingSaveReqVoFromJSON(json: any): PackingSaveReqVo {
    return PackingSaveReqVoFromJSONTyped(json, false);
}

export function PackingSaveReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingSaveReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'packingGoodsVersion': json['packingGoodsVersion'],
        'boxes': json['boxes'] == null ? undefined : ((json['boxes'] as Array<any>).map(BoxPackItemFromJSON)),
        'pallets': json['pallets'] == null ? undefined : ((json['pallets'] as Array<any>).map(PalletPackItemFromJSON)),
    };
}

export function PackingSaveReqVoToJSON(json: any): PackingSaveReqVo {
    return PackingSaveReqVoToJSONTyped(json, false);
}

export function PackingSaveReqVoToJSONTyped(value?: PackingSaveReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'packingGoodsVersion': value['packingGoodsVersion'],
        'boxes': value['boxes'] == null ? undefined : ((value['boxes'] as Array<any>).map(BoxPackItemToJSON)),
        'pallets': value['pallets'] == null ? undefined : ((value['pallets'] as Array<any>).map(PalletPackItemToJSON)),
    };
}

